import services from "@/services";

const state = {
  data: {},
  loading: false,
  error: null,
};

const mutations = {
  setLoading: (state, bool) => {
    state.loading = bool;
  },
};

const actions = {
  create({ commit, dispatch }, payload) {
    payload.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    commit("setLoading", true);
    dispatch("setLoadingGlobal", true, { root: true })
    services.setHeader();
    return new Promise((resolve, reject) => {
      services
        .post(`report-generate`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("setLoading", false);
          dispatch("setLoadingGlobal", false, { root: true })
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
